import React from 'react';
import _ from 'lodash';

import PositionedGoodyHOC from '../PositionedGoodyHOC';
import { POSITIONED_GOODY_REFS } from '../../../../constants';

class Cat extends PositionedGoodyHOC {
	// 1
	render() {
		const style = {
			st9: {
				fill: '#EFEFEF',
			},
			st52: {
				fill: '#1C1C1C',
			},
		};
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="62.0626823" cy="20.2777004" />
				<path style={style.st9} d="M29.9228516,43.605957c-0.2138672,0-0.4287109-0.0014648-0.6455078-0.0039062
					C7.8779297,43.3286133,6.6064453,27.4970703,5.6777344,15.9375C5.5625,14.4980469,5.4501953,13.0966797,5.3056641,11.7636719
					l2.9824219-0.3232422c0.1474609,1.359375,0.2626953,2.7885742,0.3798828,4.2568359
					c0.9287109,11.5620117,1.9814453,24.6665039,20.6484375,24.9047852c7.3212891,0.1074219,12.5625-1.4985352,15.9414062-4.8686523
					c4.1171875-4.1088867,4.9355469-10.5332031,5.0595703-16.59375v-4.7602539c0-0.0097656,0-0.0195312,0-0.0292969
					l1.3916016-0.0151367l-1.28125-0.5214844C52.0830078,9.7504883,56.4287109,7.125,61.5,7.125h1
					c5.0712891,0,9.4169922,2.6254883,11.0722656,6.6884766L72.3125,14.3266602l1.3701172,0.0073242v4.953125
					c0.1259766,6.0126953,0.9414062,12.0732422,4.9541016,16.1538086c3.3730469,3.4291992,8.6318359,5.1171875,16.0751953,5.1611328
					c0.0791016,0.0004883,0.1601562,0.0009766,0.2392578,0.0009766c18.0722656,0,19.1679688-12.1962891,20.2285156-23.9926758
					c0.1640625-1.8183594,0.3183594-3.5356445,0.5361328-5.2026367l2.9746094,0.3886719
					c-0.2099609,1.6074219-0.3613281,3.2954102-0.5224609,5.0825195
					c-1.0712891,11.9116211-2.4042969,26.7236328-23.2128906,26.7241211c-0.0869141,0-0.1738281-0.0004883-0.2607422-0.0009766
					c-8.2822266-0.0488281-14.234375-2.0302734-18.1962891-6.0576172
					c-5.9033203-6.0019531-5.8984375-15.2963867-5.8193359-22.8637695C69.4023438,11.9038086,66.2285156,10.125,62.5,10.125h-1
					c-3.7285156,0-6.9023438,1.7788086-8.1787109,4.5556641c0.0800781,7.699707,0.0869141,17.1577148-5.9453125,23.1762695
					C43.5029297,41.7226562,37.7880859,43.605957,29.9228516,43.605957z" />
				<path style={style.st52} d="M51.8349609,19.144043c-1.8417969,0-3.453125-1.2612305-3.8876953-3.0629883
					c-0.0048828-0.019043-1.2939453-4.8339844-5.3886719-6.1889648c-3.0664062-0.8305664-7.2792969-1.4916992-12.9306641-1.4980469
					L16.8085938,8.9262695c-0.1357422,0.0205078-0.2744141,0.0341797-0.4150391,0.0405273
					c-3.8994141,0.1757812-6.5634766,3.9638672-6.5888672,4.0019531c-0.828125,1.2568359-2.2900391,1.9389648-3.7871094,1.7753906
					c-1.4960938-0.1679688-2.7705078-1.1611328-3.2988281-2.5708008l-2-5.3334961
					C0.2685547,5.6391602,0.4208984,4.2949219,1.1298828,3.2260742c0.7080078-1.0693359,1.8867188-1.7338867,3.1679688-1.7871094
					l25.0820312-1.0415039c0.0556641-0.0024414,0.1103516-0.003418,0.1660156-0.003418
					c6.1113281,0,10.9179688,0.6899414,14.6494141,1.6538086c0.109375,0.0214844,0.21875,0.0483398,0.328125,0.0795898
					c0.0791016,0.0229492,0.15625,0.0458984,0.234375,0.0693359c7.5263672,2.0581055,10.4707031,5.2075195,10.9091797,5.71875
					c0.7744141,0.9042969,1.1064453,2.1064453,0.9052734,3.2802734l-0.7939453,4.625
					c-0.3212891,1.8706055-1.9121094,3.2578125-3.8095703,3.3208008
					C51.9238281,19.1435547,51.8789062,19.144043,51.8349609,19.144043z" />
				<path style={style.st9} d="M8.9638672,8.019043h-3c-0.828125,0-1.5-0.6713867-1.5-1.5s0.671875-1.5,1.5-1.5h3
					c0.828125,0,1.5,0.6713867,1.5,1.5S9.7919922,8.019043,8.9638672,8.019043z" />
				<path style={style.st52} d="M72.1650391,19.144043c-0.0439453,0-0.0888672-0.0004883-0.1337891-0.0024414
					c-1.8974609-0.0629883-3.4882812-1.4501953-3.8095703-3.3208008l-0.7939453-4.625
					c-0.2011719-1.1738281,0.1308594-2.3759766,0.9052734-3.2802734c0.4384766-0.5112305,3.3828125-3.6606445,10.9091797-5.71875
					c0.078125-0.0234375,0.1552734-0.0463867,0.234375-0.0693359c0.109375-0.03125,0.21875-0.0581055,0.328125-0.0795898
					c3.7314453-0.9638672,8.5380859-1.6538086,14.6494141-1.6538086c0.0556641,0,0.1103516,0.0009766,0.1660156,0.003418
					l25.0820312,1.0415039c1.28125,0.0532227,2.4599609,0.7177734,3.1679688,1.7871094
					c0.7089844,1.0688477,0.8613281,2.4130859,0.4111328,3.6137695l-2,5.3334961
					c-0.5283203,1.409668-1.8027344,2.402832-3.2988281,2.5708008c-1.4960938,0.1640625-2.9589844-0.5180664-3.7871094-1.7753906
					c-0.0087891-0.0126953-2.6513672-3.8242188-6.5888672-4.0019531c-0.140625-0.0063477-0.2792969-0.0200195-0.4150391-0.0405273
					L94.3720703,8.394043c-5.6728516,0.0063477-9.90625,0.6787109-12.9785156,1.5141602
					c-4.0791016,1.3808594-5.3291016,6.1240234-5.3408203,6.1728516
					C75.6191406,17.8823242,74.0068359,19.144043,72.1650391,19.144043z" />
				<path style={style.st9} d="M118.0361328,8.019043h-3c-0.828125,0-1.5-0.6713867-1.5-1.5s0.671875-1.5,1.5-1.5h3
					c0.828125,0,1.5,0.6713867,1.5,1.5S118.8642578,8.019043,118.0361328,8.019043z" />
			</g>
		);
	}
}

class Tortoise extends PositionedGoodyHOC {
	// 1
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="32.6929092" cy="10.5874405" />
				<path fill="#EFEFEF" d="M15.6859245,23.0090256c-0.1138783,0-0.2282753-0.0007801-0.3437138-0.0020809
					C3.9476767,22.8613472,3.2706501,14.4315348,2.77614,8.2764158C2.714781,7.5099516,2.6549823,6.7637663,2.5780239,6.0539804
					l1.5880485-0.1721168C4.2445908,6.605689,4.3059497,7.3666945,4.3683486,8.1484985
					c0.4945102,6.1564188,1.055059,13.134161,10.9946613,13.2610378c3.8983631,0.0571995,6.6891479-0.797924,8.4883118-2.5924091
					c2.1922779-2.1878567,2.6280289-5.6086082,2.694067-8.8356647V7.4467726c0-0.0051999,0-0.0103998,0-0.0155997l0.7409859-0.00806
					l-0.6822262-0.2776742c0.881382-2.1634173,3.1953354-3.5614097,5.8956413-3.5614097h0.5324707
					c2.7003059,0,5.0142593,1.3979924,5.8956451,3.5614097l-0.6707878,0.2732544l0.7295456,0.0039001v2.6373882
					c0.0670776,3.2015762,0.5012703,6.4286318,2.6379089,8.601409c1.7960434,1.8259449,4.5961876,2.7247467,8.5595474,2.7481461
					c0.0421219,0.0002594,0.0852814,0.0005207,0.1273994,0.0005207c9.6229286,0,10.206356-6.4941521,10.7710648-12.7753677
					c0.0873604-0.9682212,0.1695175-1.8826227,0.2854767-2.7702456l1.583889,0.2069559
					c-0.1117973,0.8559031-0.1923981,1.7547054-0.2781944,2.7062864
					c-0.5704308,6.3425751-1.2802162,14.2295179-12.360157,14.2297792c-0.0462799,0-0.092556-0.0002613-0.1388359-0.0005207
					c-4.4100342-0.0259991-7.5793724-1.0810585-9.6889687-3.2254963c-3.1433372-3.1958561-3.1407394-8.1448584-3.0986176-12.1742592
					c-0.6796265-1.478591-2.3695946-2.4257522-4.3549156-2.4257522h-0.5324707
					c-1.9853191,0-3.6752853,0.9471612-4.3549118,2.4257522c0.0426388,4.0998588,0.046278,9.1359596-3.1656971,12.3406563
					C22.9169006,22.0062237,19.8739223,23.0090256,15.6859245,23.0090256z" />
				<path fill="#1C1C1C" d="M27.3534527,9.9838028c-0.9806995,0-1.8386822-0.671567-2.0700779-1.6309481
					c-0.0025997-0.0101395-0.6889858-2.5739489-2.8693027-3.295435c-1.6327686-0.4422512-3.8760033-0.7942843-6.8851843-0.7976642
					L8.7029829,4.5431499C8.6307039,4.55407,8.5568657,4.5613499,8.481987,4.5647297
					c-2.0763187,0.0935979-3.4948506,2.1106381-3.5083704,2.130918C4.5326653,7.3648744,3.7542405,7.7280869,2.9570963,7.6409888
					c-0.7966242-0.0894384-1.4752108-0.618268-1.7565253-1.3688731L0.1356321,3.4321921
					c-0.2397153-0.6393273-0.1585969-1.3550932,0.2189157-1.9242219C0.7315403,0.9385814,1.3591679,0.5847284,2.0413945,0.556389
					L15.3968105,0.00182C15.4264498,0.00052,15.4555693,0,15.4852085,0c3.2540951,0,5.8134842,0.3673727,7.8003654,0.8806026
					c0.058239,0.0114397,0.116478,0.0257395,0.1747169,0.0423791c0.0421181,0.0122197,0.0831985,0.0244395,0.1247978,0.0369192
					c4.0075607,1.0958782,5.5753288,2.7728453,5.8088036,3.0450597c0.4123535,0.4815106,0.5891495,1.1216178,0.4820309,1.7466455
					l-0.4227505,2.4626713c-0.1710777,0.9960403-1.0181408,1.7346859-2.0284805,1.7682247
					C27.4007721,9.9835424,27.3768539,9.9838028,27.3534527,9.9838028z" />
				<path fill="#EFEFEF" d="M4.5259051,4.0600796H2.9284968c-0.4409513,0-0.7987041-0.3574929-0.7987041-0.7987041
					s0.3577528-0.7987041,0.7987041-0.7987041h1.5974083c0.4409513,0,0.7987041,0.3574929,0.7987041,0.7987041
					S4.9668565,4.0600796,4.5259051,4.0600796z" />
				<path fill="#1C1C1C" d="M38.1786003,9.9838028c-0.0233994,0-0.0473213-0.0002604-0.0712395-0.0013008
					c-1.0103416-0.0335388-1.8574028-0.7721844-2.0284805-1.7682247L35.6561279,5.751606
					c-0.1071167-0.6250277,0.0696793-1.2651348,0.4820328-1.7466455c0.2334747-0.2722144,1.8012428-1.9491813,5.8088036-3.0450597
					c0.0415993-0.0124797,0.0826797-0.0246995,0.1247978-0.0369192c0.058239-0.0166396,0.116478-0.0309394,0.1747169-0.0423791
					C44.2333603,0.3673727,46.7927475,0,50.0468445,0c0.0296402,0,0.0587578,0.00052,0.088398,0.00182l13.3554153,0.554569
					c0.6822243,0.0283394,1.3098564,0.3821924,1.6868477,0.9515812c0.3775101,0.5691286,0.4586334,1.2848946,0.2189178,1.9242219
					l-1.0649414,2.8399236c-0.281311,0.7506051-0.9598999,1.2794347-1.7565269,1.3688731
					c-0.7966232,0.087358-1.5755692-0.2758546-2.0165176-0.9453411c-0.0046806-0.0067601-1.4117737-2.0362802-3.5083733-2.130918
					c-0.0748787-0.0033798-0.148716-0.0106597-0.220993-0.0215797l-6.8259048-0.2833943
					c-3.0206223,0.0033798-5.2747765,0.361393-6.9106636,0.8062439c-2.1719971,0.7352657-2.8375854,3.2608562-2.8438225,3.2868552
					C40.0178032,9.3119755,39.1593018,9.9838028,38.1786003,9.9838028z" />
				<path fill="#EFEFEF" d="M62.6035576,4.0600796h-1.5974083c-0.4409523,0-0.7987061-0.3574929-0.7987061-0.7987041
					s0.3577538-0.7987041,0.7987061-0.7987041h1.5974083c0.4409485,0,0.7987022,0.3574929,0.7987022,0.7987041
					S63.0445061,4.0600796,62.6035576,4.0600796z" />
			</g>
		);
	}
}

class Chicken extends PositionedGoodyHOC {
	// 1
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} fill="none" cx="42.97906" cy="13.91856" />
				<path fill="#EFEFEF" d="M20.62118,30.24834c-0.14971,0-0.3001-0.00103-0.45186-0.00274
					C5.18973,30.0542,4.29969,18.97212,3.6496,10.88042C3.56893,9.8728,3.49032,8.89185,3.38915,7.95874l2.0877-0.22627
					c0.10322,0.95156,0.18389,1.952,0.26592,2.97978c0.6501,8.09341,1.38701,17.26655,14.45391,17.43335
					c5.1249,0.0752,8.79375-1.04897,11.15899-3.40806c2.88203-2.87622,3.45488-7.37324,3.5417-11.61563V9.78975
					c0-0.00684,0-0.01367,0-0.02051l0.97412-0.0106L34.97459,9.3936c1.15869-2.84409,4.20068-4.68193,7.75059-4.68193h0.7
					c3.5499,0,6.59189,1.83784,7.75058,4.68193l-0.88184,0.35923l0.95908,0.00513v3.46719
					c0.08818,4.20889,0.65899,8.45127,3.46787,11.30767c2.36113,2.40044,6.04229,3.58203,11.25264,3.61279
					c0.05537,0.00034,0.11211,0.00068,0.16748,0.00068c12.65059,0,13.41758-8.5374,14.15997-16.79487
					c0.11485-1.27285,0.22285-2.47495,0.37529-3.64185l2.08223,0.27207c-0.14697,1.1252-0.25293,2.30679-0.36572,3.55776
					c-0.7499,8.33813-1.68301,18.70654-16.24902,18.70688c-0.06084,0-0.12168-0.00034-0.18252-0.00068
					c-5.79756-0.03418-9.96407-1.42119-12.73741-4.24033c-4.13232-4.20137-4.12891-10.70747-4.07353-16.00464
					c-0.89346-1.9438-3.11514-3.18897-5.7251-3.18897h-0.7c-2.60996,0-4.83164,1.24517-5.7251,3.18897
					c0.05605,5.38979,0.06084,12.0104-4.16172,16.22339C30.12723,28.93003,26.12684,30.24834,20.62118,30.24834z" />
				<path fill="#1C1C1C" d="M35.95965,13.125c-1.28926,0-2.41719-0.88286-2.72139-2.14409
					c-0.00342-0.01333-0.90576-3.38379-3.77207-4.33228C27.31971,6.06724,24.37069,5.60444,20.41473,5.6L11.4412,5.97256
					c-0.09502,0.01436-0.19209,0.02393-0.29053,0.02837C8.42108,6.12397,6.55624,8.77563,6.53846,8.80229
					c-0.57969,0.87979-1.60303,1.35728-2.65098,1.24277C2.84022,9.92749,1.94813,9.23228,1.57831,8.24551l-1.4-3.73345
					c-0.31514-0.84048-0.2085-1.78145,0.28779-2.52964C0.9617,1.23389,1.7868,0.7687,2.68368,0.73145L20.2411,0.00239
					C20.28006,0.00068,20.31834,0,20.35731,0c4.27793,0,7.64258,0.48296,10.25459,1.15767
					c0.07656,0.01504,0.15312,0.03384,0.22969,0.05571c0.05537,0.01606,0.10938,0.03213,0.16406,0.04854
					c5.26846,1.44067,7.32949,3.64526,7.63643,4.00313c0.54209,0.63301,0.77451,1.47451,0.63369,2.29619l-0.55576,3.2375
					c-0.2249,1.30942-1.33848,2.28047-2.6667,2.32456C36.02186,13.12466,35.99041,13.125,35.95965,13.125z" />
				<path fill="#EFEFEF" d="M5.94989,5.3375h-2.1c-0.57969,0-1.05-0.46997-1.05-1.05s0.47031-1.05,1.05-1.05h2.1
					c0.57969,0,1.05,0.46997,1.05,1.05S6.52958,5.3375,5.94989,5.3375z" />
				<path fill="#1C1C1C" d="M50.19071,13.125c-0.03076,0-0.06221-0.00034-0.09365-0.00171
					c-1.32822-0.04409-2.4418-1.01514-2.6667-2.32456l-0.55576-3.2375c-0.14082-0.82168,0.0916-1.66318,0.63369-2.29619
					c0.30693-0.35786,2.36797-2.56245,7.63643-4.00313c0.05469-0.01641,0.10869-0.03247,0.16406-0.04854
					c0.07656-0.02188,0.15313-0.04067,0.22969-0.05571C58.15047,0.48296,61.51512,0,65.79305,0
					c0.03896,0,0.07725,0.00068,0.11621,0.00239l17.55742,0.72905c0.89688,0.03726,1.72198,0.50244,2.21758,1.25098
					c0.49628,0.74819,0.60293,1.68916,0.28779,2.52964l-1.39999,3.73345c-0.36983,0.98677-1.26192,1.68198-2.30918,1.79956
					c-1.04726,0.11484-2.07129-0.36265-2.65098-1.24277c-0.00615-0.00889-1.85596-2.67695-4.61221-2.80137
					c-0.09844-0.00444-0.19551-0.01401-0.29053-0.02837L65.73563,5.6c-3.971,0.00444-6.93438,0.4751-9.08496,1.05991
					c-2.85537,0.9666-3.73037,4.28682-3.73857,4.321C52.60858,12.2418,51.47997,13.125,50.19071,13.125z" />
				<path fill="#EFEFEF" d="M82.30048,5.3375h-2.1c-0.57969,0-1.05-0.46997-1.05-1.05s0.47031-1.05,1.05-1.05h2.1
					c0.57969,0,1.05,0.46997,1.05,1.05S82.88017,5.3375,82.30048,5.3375z" />
			</g>
		);
	}
}

function Raybans(props) {
	const glasses = {
		Cat,
		Tortoise,
		Chicken,
	};

	const ThisRaybans = glasses[props.petType.name] || Cat;

	if (_.isUndefined(ThisRaybans)) {
		return null;
	}

	return <ThisRaybans {...props} />;
}

export default Raybans;



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Glasses/Raybans.js